import { render, staticRenderFns } from "./OrderAcceptedByProvider.vue?vue&type=template&id=cab5f70a"
import script from "./OrderAcceptedByProvider.vue?vue&type=script&lang=js"
export * from "./OrderAcceptedByProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports